<template>
  <nav aria-label="Page navigation example mb-5">
    <ul class="pagination justify-content-center">

      <li class="page-item" v-if="pageable.current !== 0">
        <router-link class="page-link"
                     :to="{path:pageable.path, query: { page: 0, size: pageable.size}}">
          First
        </router-link>
      </li>
      <li class="page-item" :class="{'disabled': start -1 < 0}">
        <router-link class="page-link"
                     :to="{path:pageable.path, query: { page: start -1, size: pageable.size}}">
          Prev
        </router-link>
      </li>
      <li class="page-item" :class="{active: pageable.current  === page}"
          v-for="(page, idx) in range(start, end - 1)" :key="idx">
        <router-link class="page-link"
                     :to="{name:pageable.name, query: { page: page, size: pageable.size}}">
          {{page+1}}
        </router-link>
      </li>
      <li class="page-item d-none">
        <a class="page-link" href="#">Next</a>
      </li>
      <li class="page-item" :class="{'disabled': pageable.total <= end}">
        <router-link class="page-link"
                     :to="{path:pageable.path, query: { page: end, size: pageable.size}}">
          Next
        </router-link>
      </li>
      <li class="page-item" v-if="pageable.current + 1 !== pageable.total">
        <router-link class="page-link"
                     :to="{path:pageable.path, query: { page: pageable.total -1, size: pageable.size}}">
          Last
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    pageable: {
      type: Object,
      default() {
        return {
          path: '',
          name: '',
          current: 0,
          total: 0,
          size: 0,
        };
      },
    },
  },
  computed: {
    start() {
      return Math.trunc(this.pageable.current / 10) * 10;
    },
    end() {
      const end = this.start + 10;
      return end > this.pageable.total ? this.pageable.total : end;
    },
  },
  methods: {
    range(start, end) {
      return Array.from(Array(end - start + 1), (_, i) => start + i);
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-link {
    color: #6c757d;
  }

  .page-item.active .page-link {
    background-color: #6c757d;
    border-color: #6c757d;
  }
</style>
